import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { CallCentreStatusFeatureState } from '../interfaces/shared.interface';
import { CallCentreStatusAPIActions } from '../actions/call-centre-status.actions';

const initialState: CallCentreStatusFeatureState =
  'Ok' as CallCentreStatusFeatureState;

const reducer: ActionReducer<CallCentreStatusFeatureState> = createReducer(
  initialState,
  on(
    CallCentreStatusAPIActions.loadedCallCentreStatusSuccessfully,
    (state, { callCentreStatus }): CallCentreStatusFeatureState =>
      callCentreStatus,
  ),
);

export function callCentreStatusReducer(
  state: CallCentreStatusFeatureState = initialState,
  action: Action,
): CallCentreStatusFeatureState {
  return reducer(state, action);
}
